export const PAYMENT_PENDING = 0
export const PAYMENT_PAID = 1

export const Statuses = [
  {
    code: PAYMENT_PENDING,
    label: 'Pending',
    color: 'orange',
    icon: 'fas fa-question-circle'
  },
  {
    code: PAYMENT_PAID,
    label: 'Paid',
    color: 'green',
    icon: 'fas fa-check-circle'
  }
]

export default Statuses



// WEBPACK FOOTER //
// ./src/utils/statuses/payment.js